import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

// import arrowOutwardWhite from "@/assets/images/user/arrowOutwardWhite.svg";
import logo from "@/assets/images/user/logo.svg";
import { ScrollArea } from "@/components/ui/scroll-area";

import SnsLink from "./SnsLink";

export default function Header() {
    const location = useLocation();
    const [isScrolled, setIsScrolled] = useState(false);
    const [menuHover, setMenuHover] = useState<number | null>(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuOn, setMenuOn] = useState<number | null>(null);

    const menuList = [
        {
            title: "GXG",
            subMenu: [
                { title: "GXG 소개", link: "/about" },
                { title: "오시는 길", link: "/location" },
                { title: "행사장 구성", link: "/map" },
            ],
        },
        {
            title: "프로그램",
            subMenu: [
                { title: "행사 스케줄", link: "/schedule" },
                { title: "THE STAGE", link: "/program/stage" },
                { title: "THE PLAY", link: "/program/play" },
                { title: "THE ART", link: "/program/art" },
                { title: "THE FOCUS", link: "/program/focus" },
                { title: "THE FESTA", link: "/program/festa" },
            ],
        },
        {
            title: "아카이브",
            subMenu: [
                { title: "GXG HISTORY", link: "/archive/history" },
                { title: "SOUND TRACK", link: "/archive/soundtrack" },
            ],
        },
        {
            title: "커뮤니티",
            subMenu: [
                { title: "공지사항", link: "/community/166" },
                { title: "관련자료", link: "/community/171" },
                { title: "자주 묻는 질문", link: "/community/faq" },
                { title: "CONTACT US", link: "/community/contact" },
            ],
        },
    ];

    // 스크롤시 헤더 배경색 변경
    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 0);
        };
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    // 페이지 이동시 모바일메뉴 닫기
    useEffect(() => {
        if (menuOpen) setMenuOpen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location]);

    return (
        <header
            className={
                "fixed top-0 left-0 w-full z-[50] transition-all " +
                "before:absolute before:content-[''] before:w-full before:h-[1px] before:top-[20px] before:bg-white before:left-0 before:z-[60] " +
                "after:absolute after:content-[''] after:w-full after:h-[65px] after:left-0 after:-bottom-[1px] after:translate-y-full after:bg-[rgba(0,0,0,0.8)] " +
                "md:before:top-[24px] xl:border-b xl:border-white xl:before:top-[50px] " +
                (menuHover !== null
                    ? "bg-[rgba(0,0,0,0.8)] after:block"
                    : isScrolled
                      ? "bg-[rgba(0,0,0,0.8)] after:hidden"
                      : "after:hidden")
            }
        >
            <div className="relative mx-auto flex w-full max-w-[1600px] items-center justify-between pt-[20px] after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-full after:bg-white after:content-[''] md:pt-[24px] xl:pt-[50px] xl:after:hidden">
                <div className="relative flex flex-1 items-center gap-[70px] px-[20px] md:px-[40px] xl:p-[0_0_0_60px]">
                    <div className="py-[18px] xl:py-0">
                        <Link to={``}>
                            <img src={logo} alt="GXG2025" />
                        </Link>
                    </div>
                    <ul className="z-[70] hidden flex-1 xl:flex" onMouseLeave={() => setMenuHover(null)}>
                        {menuList.map((menu, i) => (
                            <li
                                key={`menu_${i}`}
                                className="group relative w-full max-w-[200px]"
                                onMouseEnter={() => setMenuHover(i)}
                            >
                                <Link
                                    to={menu.subMenu && menu.subMenu[0] ? menu.subMenu[0].link : "#"}
                                    // onClick={i === 1 ? handleProgramClick : undefined}
                                    className={`relative flex items-center justify-center py-[20px] leading-[26px]
                                        after:pointer-events-none after:absolute after:left-0 after:top-0 after:h-full after:w-full after:border after:border-[1px] after:border-solid after:opacity-0 after:transition-all after:duration-200 after:content-[''] after:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] group-hover:after:opacity-100`}
                                >
                                    <span
                                        className={`
                                            font-['GongGothicMedium'] text-[22px] text-white transition-colors group-hover:text-primary
                                        `}
                                    >
                                        {menu.title}
                                    </span>
                                </Link>
                                {menuHover === i && (
                                    <ul
                                        className={`absolute bottom-0 flex translate-y-full ${i === 1 || i === 3 ? "left-1/2 -translate-x-1/2" : "left-0"}`}
                                    >
                                        {menu.subMenu.length > 0 ? (
                                            menu.subMenu.map((subMenu, j) => (
                                                <li key={`sub_menu_${j}`} className="w-[200px] flex-none">
                                                    <Link
                                                        to={subMenu.link}
                                                        className="relative block py-[20px] text-center font-['GongGothicMedium'] text-[20px] font-[500] leading-[26px] text-[rgba(255,255,255,0.6)] transition-all after:absolute after:bottom-0 after:left-0 after:h-[4px] after:w-full after:bg-gradient-to-r after:from-[#E64C88] after:to-[#3734C3] after:opacity-0 after:transition-all after:content-[''] hover:text-white hover:after:opacity-100"
                                                    >
                                                        {subMenu.title}
                                                    </Link>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="h-[26px] w-[200px] py-[20px] text-center font-['GongGothicMedium'] text-[20px] font-[500] text-[rgba(255,255,255,0.6)]">
                                                COMING SOON
                                            </li>
                                        )}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
                <SnsLink className="hidden xl:flex" />
                {/* <Link
                    to={`/landing`}
                    className="group fixed bottom-0 right-0 z-50 flex h-[62px] w-[305px] items-center border border-primary bg-black font-['GongGothicMedium'] text-[16px] text-white xl:static xl:flex xl:h-[66px] xl:w-auto xl:items-center xl:border-none xl:border-white xl:bg-transparent xl:text-[20px]"
                >
                    <p className="flex flex-1 items-start justify-center bg-black py-[19px] tracking-normal transition-all duration-300 xl:border-l xl:border-r xl:border-white xl:px-[24px] xl:group-hover:bg-white xl:group-hover:text-black">
                        <span>GXG 3</span>
                        <span className="text-[12px] xl:text-[14px]">rd&nbsp;&nbsp;</span>
                        <span>SOUND TRACK</span>
                    </p>
                    <span className="flex size-[62px] items-center justify-center bg-primary transition-all duration-300 xl:size-[66px] xl:border-r xl:border-t xl:border-white xl:px-[10px]">
                        <img src={arrowOutwardWhite} alt="화살표" />
                    </span>
                </Link> */}
                {/* 모바일일때만 노출 */}
                <button
                    type="button"
                    className="absolute right-[20px] top-[calc(50%+10px)] z-[200] size-[40px] -translate-y-1/2 md:right-[40px] md:top-[calc(50%+12px)] xl:hidden"
                    onClick={() => setMenuOpen(!menuOpen)}
                >
                    <span
                        className={`absolute left-1/2 top-1/2 h-[3px] w-[30px] -translate-x-1/2 transform bg-white transition-all duration-500  ${menuOpen ? "-translate-y-1/2 rotate-45" : "-translate-y-[calc(50%+9px)]"}`}
                    />
                    <span
                        className={`absolute left-1/2 top-1/2 h-[3px] w-[30px] -translate-x-1/2 -translate-y-1/2 transform bg-white transition-all duration-500${menuOpen ? " opacity-0" : ""}`}
                    />
                    <span
                        className={`absolute left-1/2 top-1/2 h-[3px] w-[30px] -translate-x-1/2 transform bg-white transition-all duration-500  ${menuOpen ? "-translate-y-1/2 -rotate-45" : "-translate-y-[calc(50%-9px)]"}`}
                    />
                </button>
                <div
                    className={`
                        fixed inset-0 z-[100] flex h-full w-full flex-col justify-between bg-bgGnb bg-cover bg-right-bottom p-[86px_20px_30px] transition-all duration-300 xl:hidden
                        ${menuOpen ? "opacityb-100 visible" : "invisible opacity-0"}
                    `}
                >
                    <ScrollArea className="h-[calc(100%-50px)]">
                        <ul className="flex flex-col gap-[50px] md:gap-[100px]">
                            {menuList.map((menu, i) => (
                                <li key={`menu_${i}`}>
                                    <button
                                        type="button"
                                        className={`font-['GongGothicMedium'] text-[30px] font-[500] transition-all md:text-[50px] ${menuOn === i ? "text-primary" : "text-white"}`}
                                        onClick={() => setMenuOn(menuOn === i ? null : i)}
                                    >
                                        {menu.title}
                                    </button>
                                    <ul
                                        className={`flex flex-col gap-[10px] overflow-hidden transition-all ${menuOn === i ? "h-auto pt-[12px] opacity-100 md:pt-[20px]" : "h-0 opacity-0"}`}
                                    >
                                        {menu.subMenu.length > 0 ? (
                                            menu.subMenu.map((subMenu, j) => (
                                                <li key={`sub_menu_${j}`}>
                                                    <Link
                                                        to={subMenu.link}
                                                        className="relative inline-block py-[6px] font-['GongGothicMedium'] text-[16px] text-[rgba(255,255,255,0.6)] after:absolute after:bottom-0 after:left-0 after:h-[4px] after:w-full after:bg-gradient-to-r after:from-[#E64C88] after:to-[#3734C3] after:opacity-0 after:transition-all after:content-[''] hover:text-white hover:after:opacity-100 md:py-[24px] md:text-[20px]"
                                                    >
                                                        {subMenu.title}
                                                    </Link>
                                                </li>
                                            ))
                                        ) : (
                                            <li className="w-full py-[16px] text-center font-['GongGothicMedium'] text-[20px] text-[rgba(255,255,255,0.6)] md:py-[24px]">
                                                COMING SOON
                                            </li>
                                        )}
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </ScrollArea>
                    <SnsLink />
                </div>
                {/* // 모바일일때만 노출 */}
            </div>
        </header>
    );
}
